import React, { useState, useEffect } from "react";
import DataTable from "../../components/DataTable";
import { addPermissions, fetchAllAdmins } from "../../services/admins";
import { useMutation, useQuery } from "@tanstack/react-query";
import PermissionCheckbox from "../../components/PermissionCheckbox";
import { PermButton } from "./style";
import Spinner from "../../components/Spinner";
import toast from "react-hot-toast";

const columns = [
  "ID",
  "الاسم",
  "الايميل",
  "رقم الهاتف",
  "الخريطة",
  "الزبائن",
  "السائقين",
  "طلبات القبول",
  "الأرصدة",
  "امين الحقائب",
  "الحسابات",""
];

const AdminPermissions = {
  MAP: "MAP",
  DRIVER_ACTIONS: "DRIVER_ACTIONS",
  DRIVERS: "DRIVERS",
  USERS: "USERS",
  BALANCES: "BALANCES",
  BAG_MANAGER: "BAG_MANAGER",
  ADMIN_ACCOUNT: "ADMIN_ACCOUNT",
};

const Accounts = () => {
  const [permissions, setPermissions] = useState({});

  const { data: admins = [], isLoading, isError, error } = useQuery({
    queryKey: ["admins"],
    queryFn: fetchAllAdmins,
  });

  useEffect(() => {
    if (!admins.length) return;

    const initialPerms = {};
    for (const admin of admins) {
      const adminPermObj = {};
      for (const key of Object.keys(AdminPermissions)) {
        adminPermObj[key] = admin.permissions?.includes(AdminPermissions[key]) || false;
      }
      initialPerms[admin._id] = adminPermObj;
    }
    setPermissions(initialPerms);
  }, [admins]);

  const mutation = useMutation({
    mutationFn: ({ id, permissions }) => addPermissions({ id, permissions }),
   onSuccess: () =>
    toast.success("✅ تم إرسال التصاريح بنجاح 🎉", {
      icon: "🔐",
      style: {
        fontFamily: "Noto Kufi Arabic",
        direction: "rtl",
      },
    }),
  onError: () =>
    toast.error("❌ فشل في إرسال التصاريح", {
      icon: "⚠",
      style: {
        fontFamily: "Noto Kufi Arabic",
        direction: "rtl",
      },
    })
  });

  const handleCheckboxChange = (id, key) => {
    setPermissions((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [key]: !prev[id]?.[key],
      },
    }));
  };

  const handleSend = (id) => {
    const selectedPermissions = Object.entries(permissions[id] || {})
      .filter(([, value]) => value)
      .map(([key]) => AdminPermissions[key]);

    if (!selectedPermissions.length) {
    toast.error("🚫 لم يتم تحديد أي صلاحية", {
      icon: "⚠",
      style: {
        fontFamily: "Noto Kufi Arabic",
        direction: "rtl",
      },
    })
      return;
    }

    mutation.mutate({ id, permissions: selectedPermissions });
  };

  if (isLoading) return <Spinner />;
  if (isError) return <div>❌ حدث خطأ: {error.message}</div>;

  if (!Object.keys(permissions).length)
    return <div>🔄 جاري تهيئة التصاريح...</div>;

  const mapRows = (list) =>
    list.map((admin,id) => {
      const p = permissions[admin._id] || {};
      return [
        id+1,
        admin.name ?? "—",
        admin.email ?? "—",
        admin.phone_number ?? "—",
        ...Object.keys(AdminPermissions).map((key) => (
          <PermissionCheckbox
            key={key}
            isChecked={p[key] || false}
            onChange={() => handleCheckboxChange(admin._id, key)}
          />
        )),
        <PermButton onClick={() => handleSend(admin._id)}>إرسال</PermButton>,
        ""
      ];
    });

  return <DataTable columns={columns} data={mapRows(admins)} />;
};

export default Accounts;
